export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_LIMIT = DEFAULT_PAGE_SIZE;

export const ENTRIES_SELECT_PAGE_SIZE = 200;
